
import React, { useState, useRef, useEffect } from 'react';
import './Library.css';
import music from '../assest/music.png';
import sound from '../assest/sound.png';
import frequency from '../assest/frequency.png';
import central from '../assest/central.png';
import { useData } from '../utils/DataContext';

const Library = () => {
  // State and ref declarations
  const [activeBook, setActiveBook] = useState(null);
  const [expandedChapter, setExpandedChapter] = useState(null);
  const [expandedSubChapter, setExpandedSubChapter] = useState(null);
  const { selectedId } = useData();
  const bookRefs = useRef({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const allChapters = [

    {
      id: 1,
      title: 'ಯೋಗ ಚಿಕಿತ್ಸೆ ಮತ್ತು ಸಿಬಿಟಿ',
      subChapters: [

        {
          id: 1,
          title: 'ಯೋಗ ಚಿಕಿತ್ಸೆ',
          subSubChapters: [
            {
              id: 1,
              title: 'ಶೀತಲೀಕರಣ ವ್ಯಾಯಾಮಗಳು',
              books: [
                { id: 1, title: 'ಶ್ವಾಸಕ್ರಿಯೆ ೧ : ಅಭ್ಯಾಸದ ವಿಧಾನ', cover: music, pdf: '/pdf/1.pdf' },
                { id: 2, title: 'ಶ್ವಾಸಕ್ರಿಯೆ ೨ : ಅಭ್ಯಾಸದ ವಿಧಾನ', cover: sound, pdf: '/pdf/2.pdf' },
                { id: 3, title: 'ಅರ್ಧಚಕ್ರಾಸನ ಮತ್ತು ಪಾದಹಸ್ತಾಸನ: ಅಭ್ಯಾಸದ ವಿಧಾನ', cover: frequency, pdf: '/pdf/3.pdf' },
                { id: 4, title: 'ಕಟೀಚಕ್ರಾಸನ ಅಭ್ಯಾಸದ ವಿಧಾನ', cover: central, pdf: '/pdf/4.pdf' },
              ],
            },
            {
              id: 2,
              title: 'ಪ್ರಾಣಾಯಾಮಗಳು',
              books: [
                { id: 1, title: 'ವಿಭಾಗೀಯ ಪ್ರಾಣಾಯಾಮ', cover: music, pdf: '/pdf/5.pdf' },
                { id: 2, title: 'ಉಜ್ಜಾಯಿ ಪ್ರಾಣಾಯಾಮ', cover: sound, pdf: '/pdf/6.pdf' },
                { id: 3, title: 'ನಾಡೀಶುದ್ಧಿ ಪ್ರಾಣಾಯಾಮ', cover: frequency, pdf: '/pdf/7.pdf' },
                { id: 4, title: 'ಭಸ್ತ್ರಿಕ ಪ್ರಾಣಾಯಾಮ', cover: central, pdf: '/pdf/8.pdf' },
                { id: 5, title: 'ಕಪಾಲಭಾತಿ', cover: central, pdf: '/pdf/9.pdf' },
              ],
            },
          ],
        },
        // CBT
        {
          id: 2,
          title: 'ಸಿಬಿಟಿ',
          subSubChapters: [
            {
              id: 1,
              title: 'ಸ್ನಾಯು ಆರಾಮ',
              books: [
                { id: 1, title: 'ಪ್ರೋಗ್ರೆಸಿವ್ ಸ್ನಾಯು ಆರಾಮ', cover: music, pdf: '/pdf/19.pdf' },
              ],
            },
            {
              id: 2,
              title: 'ತರಬೇತಿ ವಿಧಾನಗಳು',
              books: [
                { id: 1, title: 'ಸುಧಾರಿತ ಆರಾಮ ತರಬೇತಿ ವಿಧಾನಗಳು', cover: sound, pdf: '/pdf/20.pdf' },
              ],
            },
            {
              id: 3,
              title: 'ದೈನಂದಿನ ಜೀವನದ ಮೇಲೆ ಟಿನಿಟಸ್',
              books: [
                { id: 1, title: 'ದೈನಂದಿನ ಜೀವನದ ಮೇಲೆ ಟಿನಿಟಸ್ ಪರಿಣಾಮವನ್ನು ಕಡಿಮೆ ಮಾಡುವುದು', cover: frequency, pdf: '/pdf/21.pdf' },
              ],
            },
            {
              id: 4,
              title: 'ಹಂತ ಹಂತವಾಗಿ ಮಾರ್ಗದರ್ಶನ',
              books: [
                { id: 1, title: 'ಧನಾತ್ಮಕ ಚಿತ್ರಣ', cover: music, pdf: '/pdf/22.pdf' },
                { id: 2, title: 'ಧ್ವನಿ ಪುಷ್ಟ ಷ್ಟೀಕರಣ', cover: sound, pdf: '/pdf/cbt4-2.pdf' },
                { id: 3, title: 'ಟಿನ್ನಿಟಸ್ ಅನ್ನು ಮರು ವ್ಯಾಖ್ಯಾನಿಸುವುದು', cover: frequency, pdf: '/pdf/23.pdf' },
                { id: 4, title: 'ಉತ್ತಮವಾಗಿ ನಿದ್ರಿಸಲು ಮಾರ್ಗಸೂಚಿಗಳು', cover: central, pdf: '/pdf/24.pdf' },
                { id: 5, title: 'ಗಮನವನ್ನು ಬದಲಾಯಿಸುವುದು ಎಂದರೇನು?', cover: music, pdf: '/pdf/25.pdf' },
                { id: 6, title: 'ಗಮನವನ್ನು ಸುಧಾರಿಸುವುದು', cover: sound, pdf: '/pdf/26.pdf' },
                { id: 7, title: 'ನಿಮ್ಮನ್ನು ನೀವೊಂದು ಸವಾಲು ಮಾಡಿಕೊಳ್ಳಿ', cover: frequency, pdf: '/pdf/27.pdf' },
                { id: 8, title: 'ಧ್ವನಿ ಸೂಕ್ಷ್ಮತೆಯನ್ನು ಕಡಿಮೆ ಮಾಡುವುದು', cover: central, pdf: '/pdf/28.pdf' },
                { id: 9, title: 'ಸವಾಲಿನ ಆಲೋಚನೆಗಳು (ಅರಿವಿನ ಪುನರ್ ರಚನೆ)', cover: music, pdf: '/pdf/29.pdf' },
                { id: 10, title: 'ಸಂವಹನ ತಂತ್ರಗಳು', cover: sound, pdf: '/pdf/30.pdf' },
                { id: 11, title: 'ಟಿನ್ನಿಟಸನ್ನು ಕೇಳಿಸಿಕೊಳ್ಳಿ', cover: frequency, pdf: '/pdf/31.pdf' },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: 'ವೆಸ್ಟಿಬ್ಯುಲರ್',
      subChapters: [
        {
          id: 1,
          title: 'ವೆಸ್ಟಿಬ್ಯುಲರ್ ವ್ಯಾಧಿಗಳು',
          subSubChapters: [
            {
              id: 1,
              title: 'ವ್ಯಾಯಾಮಗಳು',
              books: [
                { id: 1, title: 'ತ್ರಾಟಕ ವ್ಯಾಯಾಮಗಳು', cover: music, pdf: '/pdf/41.pdf' },
                { id: 2, title: ' ಸಮತೋಲನ ವ್ಯಾಯಾಮಗಳು', cover: sound, pdf: '/pdf/42.pdf' },
                { id: 3, title: 'ಶೀತಲೀಕರಣ ವ್ಯಾಯಾಮಗಳು', cover: frequency, pdf: '/pdf/43.pdf' },
                { id: 4, title: 'ಉಸಿರಾಟದ ವ್ಯಾಯಾಮಗಳು', cover: frequency, pdf: '/pdf/44.pdf' },
                { id: 5, title: 'ಆಸನಗಳು', cover: frequency, pdf: '/pdf/45.pdf' },
                { id: 6, title: 'ಪ್ರಾಣಾಯಾಮ', cover: frequency, pdf: '/pdf/46.pdf' },
                { id: 7, title: 'ವಿಶ್ರಾಂತಿ ಮತ್ತು ಪಠಣ', cover: frequency, pdf: '/pdf/47.pdf' }

              ],
            },

          ],
        },
        {
          id: 2,
          title: 'ವೆಸ್ಟಿಬ್ಯುಲರ್ ಪುನರ್ವಸತಿ ಚಿಕಿತ್ಸೆಯಲ್ಲಿ ಒಳಗೊಂಡಿರುವ ಹಂತಗಳು ಯಾವುವು',
          subSubChapters: [
            {
              id: 1,
              title: 'ಹಂತಗಳು',
              books: [
                { id: 1, title: 'ಹಂತ ೧', cover: central, pdf: '/pdf/48.pdf' },
                { id: 1, title: 'ಹಂತ ೨', cover: central, pdf: '/pdf/49.pdf' },
                { id: 1, title: 'ಹಂತ ೩', cover: central, pdf: '/pdf/50.pdf' },
                { id: 1, title: 'ಹಂತ ೪', cover: central, pdf: '/pdf/51.pdf' },
              ],
            }

          ],
        },

      ],
    },
    {
      id: 5,
      title: 'Counselling',
      subChapters: [

        {
          id: 1,
          title: 'Cochlear Implants',
          subSubChapters: [
            {
              id: 1,
              title: 'How to use Cochlear Implants',
              books: [
                { id: 1, title: 'How to Wear', cover: music, pdf: '/pdf/1.pdf' },
                { id: 2, title: 'Parts of cochlear implant', cover: sound, pdf: '/pdf/2.pdf' },
                { id: 3, title: 'Switching Batteries', cover: frequency, pdf: '/pdf/3.pdf' },
                { id: 4, title: 'Changing Batteries', cover: central, pdf: '/pdf/4.pdf' },
                { id: 5, title: 'Changing Program', cover: central, pdf: '/pdf/4.pdf' },
              ],
            },
            {
              id: 2,
              title: 'Care and Maintenance',
              books: [
                { id: 1, title: 'Microphone Guard', cover: music, pdf: '/pdf/5.pdf' },
                { id: 2, title: 'Coil Wand', cover: sound, pdf: '/pdf/6.pdf' },
                { id: 3, title: 'Dry aid Kit', cover: frequency, pdf: '/pdf/7.pdf' },
                { id: 4, title: 'Monitor Earphones', cover: central, pdf: '/pdf/8.pdf' },

              ],
            },
            {
              id: 3,
              title: 'Dos and Donts',
              books: [
                { id: 1, title: 'Dos', cover: music, pdf: '/pdf/5.pdf' },
                { id: 2, title: 'Donts', cover: sound, pdf: '/pdf/6.pdf' },


              ],
            },
            {
              id: 4,
              title: 'Troubleshooting',
              books: [
                { id: 1, title: 'CI Troubleshooting 1', cover: music, pdf: '/pdf/5.pdf' },
                { id: 2, title: 'CI Troubleshooting 2', cover: sound, pdf: '/pdf/6.pdf' },
                { id: 3, title: 'CI Troubleshooting 3', cover: frequency, pdf: '/pdf/7.pdf' },
                { id: 4, title: 'CI Troubleshooting 4', cover: central, pdf: '/pdf/8.pdf' },

              ],
            },
          ],
        },

      ],
    },
    {
      id: 6,
      title: 'Counselling',
      subChapters: [

        {
          id: 1,
          title: 'Hearing Aids',
          subSubChapters: [
            {
              id: 1,
              title: 'Understanding Hearing Aids',
              books: [
                { id: 1, title: 'How to Change Batteries', cover: music, pdf: '/pdf/1.pdf' },
                { id: 2, title: 'How to Wear Hearing Aids', cover: sound, pdf: '/pdf/2.pdf' },
                { id: 3, title: 'Parts of Hearing Aids', cover: frequency, pdf: '/pdf/3.pdf' },
                { id: 4, title: 'Parts of RIC', cover: central, pdf: '/pdf/4.pdf' },

              ],
            },
            {
              id: 2,
              title: 'Care and Maintenance',
              books: [
                { id: 1, title: 'Changing the Tube', cover: music, pdf: '/pdf/5.pdf' },
                { id: 2, title: 'How to Charge Hearing Aids', cover: sound, pdf: '/pdf/6.pdf' },
                { id: 3, title: 'Cleaning Hearing Aids', cover: frequency, pdf: '/pdf/7.pdf' },
                { id: 4, title: 'Hearing Aid Box', cover: central, pdf: '/pdf/8.pdf' },
                { id: 5, title: 'Use Dehumidifiers', cover: central, pdf: '/pdf/9.pdf' },

              ],
            },
            {
              id: 3,
              title: 'Dos and Donts',
              books: [
                { id: 1, title: 'Dos', cover: music, pdf: '/pdf/5.pdf' },
                { id: 1, title: 'Donts', cover: music, pdf: '/pdf/5.pdf' },



              ],
            },
            {
              id: 4,
              title: 'Troubleshooting',
              books: [
                { id: 1, title: 'HA Troubleshooting 1', cover: music, pdf: '/pdf/5.pdf' },
                { id: 2, title: 'HA Troubleshooting 2', cover: sound, pdf: '/pdf/6.pdf' },
                { id: 3, title: 'HA Troubleshooting 3', cover: frequency, pdf: '/pdf/7.pdf' },
                { id: 4, title: 'HA Troubleshooting 4', cover: central, pdf: '/pdf/8.pdf' },

              ],
            },
          ],
        },

      ],
    },
  ];

  // Filter chapters based on selectedId
  const filteredChapters = selectedId
    ? allChapters.filter(chapter => chapter.id === selectedId)
    : allChapters;

  // Handle sidebar click to animate & scroll to book card
  const handleSidebarClick = (chapterId, subChapterId, subSubChapterId, bookId) => {
    const bookKey = `${chapterId}-${subChapterId}-${subSubChapterId}-${bookId}`;
    setActiveBook(bookKey);
    if (bookRefs.current[bookKey]) {
      bookRefs.current[bookKey].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleAnimationEnd = () => {
    setActiveBook(null);
  };

  // Open PDF on clicking the book card
  const handleBookClick = (pdfUrl) => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    }
  };

  // Toggle chapter expansion
  const toggleChapter = (chapterId) => {
    setExpandedChapter(expandedChapter === chapterId ? null : chapterId);
    setExpandedSubChapter(null);
  };

  // Toggle subchapter expansion
  const toggleSubChapter = (subChapterId) => {
    setExpandedSubChapter(expandedSubChapter === subChapterId ? null : subChapterId);
  };

  return (
    <div className="library-container">
      {/* Sidebar */}
      <div className="sidebar">
        <h2>Chapters</h2>
        <ul>
          {filteredChapters.map((chapter) => (
            <li key={chapter.id}>
              <span
                className="chapter-link"
                onClick={() => toggleChapter(chapter.id)}
                style={{ cursor: 'pointer' }}
              >
                {chapter.title}
              </span>
              {expandedChapter === chapter.id && chapter.subChapters && (
                <ul>
                  {chapter.subChapters.map((subChapter) => (
                    <li key={subChapter.id}>
                      <span
                        className="subchapter-link"
                        onClick={() => toggleSubChapter(subChapter.id)}
                        style={{ cursor: 'pointer' }}
                      >
                        {subChapter.title}
                      </span>
                      {expandedSubChapter === subChapter.id && subChapter.subSubChapters && (
                        <ul>
                          {subChapter.subSubChapters.map((subSubChapter) => (
                            <li key={subSubChapter.id}>
                              <span className="subsubchapter-link">
                                {subSubChapter.title}
                              </span>
                              {subSubChapter.books && subSubChapter.books.length > 0 && (
                                <ul>
                                  {subSubChapter.books.map((book) => (
                                    <li key={book.id}>
                                      <a
                                        href={`#book-${chapter.id}-${subChapter.id}-${subSubChapter.id}-${book.id}`}
                                        className="book-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleSidebarClick(
                                            chapter.id,
                                            subChapter.id,
                                            subSubChapter.id,
                                            book.id
                                          );
                                        }}
                                      >
                                        {book.title}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* Content Area */}
      <div className="content">
        {filteredChapters.map((chapter) => (
          <div key={chapter.id} className="chapter-section">
            <h2 className="chapter-title">{chapter.title}</h2>

            {chapter.subChapters && chapter.subChapters.map((subChapter) => (
              <div key={subChapter.id} className="subchapter-section">
                <h3 className="subchapter-title">{subChapter.title}</h3>

                {subChapter.subSubChapters && subChapter.subSubChapters.map((subSubChapter) => (
                  <div
                    id={`subsubchapter-${chapter.id}-${subChapter.id}-${subSubChapter.id}`}
                    key={subSubChapter.id}
                    className="subsubchapter-section"
                  >
                    <h4 className="subsubchapter-title">{subSubChapter.title}</h4>

                    <div className="books-grid">
                      {subSubChapter.books && subSubChapter.books.map((book) => {
                        const bookKey = `${chapter.id}-${subChapter.id}-${subSubChapter.id}-${book.id}`;
                        return (
                          <div
                            id={`book-${chapter.id}-${subChapter.id}-${subSubChapter.id}-${book.id}`}
                            key={book.id}
                            className={`book-card ${activeBook === bookKey ? 'active' : ''}`}
                            ref={(el) => (bookRefs.current[bookKey] = el)}
                            onClick={() => handleBookClick(book.pdf)}
                            onAnimationEnd={handleAnimationEnd}
                          >
                            <img src={book.cover} alt={book.title} className="book-cover" />
                            <h5 className="book-title">{book.title}</h5>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Library;